<script setup lang="ts">
import { ref } from 'vue';

const faqItems = [
  {
    question: 'Czy moje dane są bezpieczne?',
    answer: 'Tak. Wszystkie pliki są szyfrowane end-to-end i przechowywane zgodnie z RODO. Nigdy nie udostępniamy Twoich danych osobowych firmom trzecim. Po zakończeniu procesu optymalizacji możesz usunąć swoje dane jednym kliknięciem.'
  },
  {
    question: 'Czy systemy ATS odczytają polskie znaki?',
    answer: 'Oczywiście! Nasze CV są w pełni kompatybilne z systemami ATS, w tym z polskimi znakami diakrytycznymi (ą, ć, ę, ł, ń, ó, ś, ź, ż). Używamy standardowych formatów PDF z warstwą tekstową, które są uniwersalnie czytane przez wszystkie popularne systemy rekrutacyjne.'
  },
  {
    question: 'Czy AI dodaje informacje, których nie mam w CV?',
    answer: 'Nigdy. Nasza No-Lie Policy gwarantuje, że używamy wyłącznie informacji z Twojego CV. AI tylko rekontekstualizuje Twoje prawdziwe doświadczenie, aby lepiej pasowało do oferty. Nie dodajemy umiejętności, projektów ani certyfikatów, których nie posiadasz.'
  },
  {
    question: 'Czy AI dodaje informacje, których nie mam w CV?',
    answer: 'Nigdy. Nasza No-Lie Policy gwarantuje, że używamy wyłącznie informacji z Twojego CV. AI tylko rekontekstualizuje Twoje prawdziwe doświadczenie, aby lepiej pasowało do oferty. Nie dodajemy umiejętności, projektów ani certyfikatów, których nie posiadasz.'
  },
  {
    question: 'Czy AI dodaje informacje, których nie mam w CV?',
    answer: 'Nigdy. Nasza No-Lie Policy gwarantuje, że używamy wyłącznie informacji z Twojego CV. AI tylko rekontekstualizuje Twoje prawdziwe doświadczenie, aby lepiej pasowało do oferty. Nie dodajemy umiejętności, projektów ani certyfikatów, których nie posiadasz.'
  }
];

const openItems = ref<number[]>([0]);

const isOpen = (index: number) => openItems.value.includes(index);

const toggleItem = (index: number) => {
  if (isOpen(index)) {
    openItems.value = openItems.value.filter((item) => item !== index);
    return;
  }
  openItems.value = [...openItems.value, index];
};
</script>

<template>
  <section id="faq" class="py-24 bg-slate-50">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-14">
        <h2 class="text-3xl font-bold text-slate-900 mb-4">Najczęściej zadawane pytania</h2>
        <p class="text-lg text-slate-600">Krótko i konkretnie: jak działa CV-Tailor i czego możesz się spodziewać.</p>
      </div>

      <div class="space-y-4">
        <article
          v-for="(item, index) in faqItems"
          :key="`${item.question}-${index}`"
          class="bg-white border border-slate-200 rounded-2xl"
        >
          <button
            type="button"
            class="w-full p-6 text-left flex items-center justify-between gap-4"
            :aria-expanded="isOpen(index)"
            @click="toggleItem(index)"
          >
            <span class="text-lg font-semibold text-slate-900">{{ item.question }}</span>
            <span
              class="text-slate-500 text-xl leading-none transition-transform duration-300 ease-out"
              :class="isOpen(index) ? 'rotate-45' : 'rotate-0'"
            >+</span>
          </button>

          <div
            class="grid transition-all duration-300 ease-out"
            :class="isOpen(index) ? 'grid-rows-[1fr] opacity-100 pb-6' : 'grid-rows-[0fr] opacity-0'"
          >
            <div
              class="overflow-hidden px-6 cursor-pointer"
              @click="toggleItem(index)"
            >
              <p class="text-slate-600 leading-relaxed">{{ item.answer }}</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>
